import myVideo from './Images/UsMeeting.mov'; // Update the path as needed

const Video = () => {

  return (
    <div style={{ height: 750 }} className='bodyJ'>
      <video controls autoPlay loop muted style={{ width: '50%', paddingTop: 60 }}>
        {/* Set the src attribute of the source tag to the imported video variable */}
        <source src={myVideo} type="video/quicktime" />
        {/* Fallback text for browsers that don't support the video tag */}
        Your browser does not support the video tag.
      </video>
    </div >


  );
}

export default Video;

